import { PALETTE_SET_OPEN } from '../actionTypes';

// Open/closed state of the global record search palette (CD-5425). Kept out of the `clicks`
// reducer, which models navigation - the palette is an overlay, not a nav destination.
const initialState = {
  open: false,
  // A printable character forwarded from the flyout's decoy control, so typing into what looks
  // like a field opens the palette already seeded with that keystroke instead of doing nothing.
  seedText: '',
};

export default function palette(state = initialState, action) {
  switch (action.type) {
    case PALETTE_SET_OPEN: {
      return {
        ...state,
        open: action.payload.open,
        seedText: action.payload.open ? action.payload.seedText || '' : '',
      };
    }

    default:
      return state;
  }
}
